import {NgModule} from '@angular/core';
import {RegisterPageComponent} from './register-page.component';
import {PageCommonModule} from '../shared/page-common.module';
import {VerifyRegistrationPageComponent} from './verify/verify-registration-page.component';
import {ResendRegistrationVerificationPageComponent} from './resend-verification/resend-verification-page.component';
import {FormsModule} from '../../components/forms/forms.module';
import {RecaptchaModule} from 'ng2-recaptcha';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        RecaptchaModule,
        NgbModule
    ],
    declarations: [
        RegisterPageComponent,
        VerifyRegistrationPageComponent,
        ResendRegistrationVerificationPageComponent
    ]
})
export class RegisterPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/register/register-page.module.ts